<template>
  <DialogLayout
    title="詳細検索"
    :visible.sync="dialogVisible"
    width="65em"
    @open="open"
    class="detail-search-dialog"
  >
    <template #form>
      <FeesForStopForm
        ref="feesForStopForm"
        v-model="feesForStopForm"
        label-width="10em"
        formMode="search"
        :autocomplete-registration-symbol-set="autocompleteRegistrationSymbolSet"
        :autocomplete-model-code-set="autocompleteModelCodeSet"
        :autocomplete-customer-code-set="autocompleteCustomerCodeSet"
        :autocomplete-airport-code-set="autocompleteAirportCodeSet"
      />
    </template>
    <template #footer>
      <SearchDialogFooter
        @clear="clickClear"
        @search="clickSearch"
      />
    </template>
 </DialogLayout>
</template>

<script>
import DialogLayout from '@/components/templates/DialogLayout.vue'
import FeesForStopForm from '@/components/organisms/dialog/calculation/FeesForStopForm.vue'
import SearchDialogFooter from '@/components/organisms/dialog/SearchDialogFooter.vue'

export default {
  components: {
    DialogLayout,
    FeesForStopForm,
    SearchDialogFooter
  },
  props: {
    model: Object,
    autocompleteRegistrationSymbolSet: {
      type: Array,
      default: () => ([])
    },
    autocompleteModelCodeSet: {
      type: Array,
      default: () => ([])
    },
    autocompleteCustomerCodeSet: {
      type: Array,
      default: () => ([])
    },
    autocompleteAirportCodeSet: {
      type: Array,
      default: () => ([])
    },
    visible: Boolean
  },
  data () {
    return {
      feesForStopForm: {
        registration_symbol: undefined,
        action_time: undefined,
        action_type: undefined,
        billing_ym: this.getDefaultBillingYm(),
        bill_to_code: undefined,
        route_code: undefined,
        callsign: undefined,
        departure_airport_code: undefined,
        destination_airport_code: undefined,
        model_code: undefined,
        stop_fee_without_tax: undefined,
        stop_fee_tax: undefined,
        stop_fee_with_tax: undefined,
        tax: undefined,
        taxation: undefined,
        flight_purpose_code: undefined,
        aircraft_type: undefined,
        weight: undefined,
        stops: undefined,
        stop_minutes: undefined,
        unit_fee: undefined,
        manual_data_only: false,
        automatic_data_only: false
      }
    }
  },
  computed: {
    dialogVisible: {
      get () {
        return this.visible
      },
      set (value) {
        this.$emit('update:visible', value)
      }
    }
  },
  mounted () {
    // console.log('RegistrationSymbolMasterDetailSearchDialog.mounted')
  },
  methods: {
    clickClear () {
      this.$refs.feesForStopForm.clearFields()
    },
    clickSearch () {
      this.$refs.feesForStopForm.validate()
        .then((valid) => {
          sessionStorage.setItem('feesForStopSearchCond', JSON.stringify(this.feesForStopForm))
          this.dialogVisible = false
          this.$emit('search', this.feesForStopForm)
        })
    },
    open () {
      const searchCond = JSON.parse(sessionStorage.getItem('feesForStopSearchCond'))
      this.$nextTick(() => {
        this.$refs.feesForStopForm.clearFields()
        if (searchCond) {
          Object.keys(this.feesForStopForm).forEach((x) => {
            this.$set(this.feesForStopForm, x, searchCond[x])
          })
          if (!this.feesForStopForm.manual_data_only) {
            this.feesForStopForm.manual_data_only = false
          }
          if (!this.feesForStopForm.automatic_data_only) {
            this.feesForStopForm.automatic_data_only = false
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
